import { render, staticRenderFns } from "./AjudaTooltip.vue?vue&type=template&id=598a005e&scoped=true&"
import script from "./AjudaTooltip.vue?vue&type=script&lang=js&"
export * from "./AjudaTooltip.vue?vue&type=script&lang=js&"
import style0 from "./AjudaTooltip.vue?vue&type=style&index=0&id=598a005e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598a005e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
